export default {
    colorShades: [
        "All Black",
        "All Gray",
        "All White",
        "All Red",
        "All Brown",
        "All Green",
        "All Blue",
        "All Orange",
        "All Yellow",
        "All Camo",
        "All Pink",
        "All Purple",
        "All Denim",
        "All Royal",
        "All Safety",
        "All Misc"
    ],
    filterOrderStatuses: [
        "NEW",
        "IN REVIEW",
        "OPEN ORDERS",
        "ON HOLD",
        "REDESIGN",
        "APPROVED",
        "PENDING AMOUNT",
        "PRODUCTION",
        "IN SHIPMENT",
        // 'COMPLETED',
        "BACK ORDER",
        "MISSING ARTWORK",
        "ARTWORK PROOF PENDING"
    ],
    address_types: [
        "Default Shipping Address",
        "Default Billing Address",
        "Additional Shipping Address",
        "Additional Billing Address"
    ],
    shipping_label: "Shipping Address",
    billing_label: "Billing Address"
};
